// src/firebaseConfig.js

import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";
// Importa las funciones de App Check y el proveedor de reCAPTCHA v3
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check"

// =================================================================
// TU CONFIGURACIÓN DE FIREBASE
// Pega aquí el objeto firebaseConfig que copiaste de la consola.
// =================================================================
const firebaseConfig = {
  apiKey: "AIzaSyAtXlOO03B6DAmVTouz1ZDGOrII5aWCncU",
  authDomain: "xcoin-plataforma.firebaseapp.com",
  projectId: "xcoin-plataforma",
  storageBucket: "xcoin-plataforma.firebasestorage.app",
  messagingSenderId: "749294641820",
  appId: "1:749294641820:web:882a3d3edec1ccaf6f0359"
};

// Inicializa la aplicación de Firebase
const app = initializeApp(firebaseConfig);

// Obtiene las instancias de cada servicio de Firebase
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, 'southamerica-west1');
const storage = getStorage(app);

// =================================================================
// INICIALIZACIÓN DE APP CHECK
// Debe ocurrir ANTES de inicializar Auth, Functions, etc.
// =================================================================

// Enable Debug Token ONLY in development to allow whitelisting in Firebase Console
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6Lc-80wsAAAAAE7GkKGX1tQPdftgBtRDgQzj6Ylk'),

  // Opcional, pero recomendado: actualiza el token automáticamente
  isTokenAutoRefreshEnabled: true
});


// =================================================================
// CONEXIÓN A LOS EMULADORES LOCALES
// Este código detecta si estás en localhost y redirige todas las
// peticiones a tu "mini-Firebase" local en lugar de a la nube.
// =================================================================

if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
  console.log("✅ Modo desarrollo: Conectando a los Emuladores de Firebase...");
  console.log("Interfaz de Emuladores disponible en http://127.0.0.1:4000/");

  // Emulador de Autenticación
  connectAuthEmulator(auth, "http://localhost:9099");

  // Emulador de Firestore
  connectFirestoreEmulator(db, 'localhost', 8080);

  // Emulador de Functions
  connectFunctionsEmulator(functions, 'localhost', 5001);

  // Emulador de Storage
  connectStorageEmulator(storage, 'localhost', 9199);
} // --- ¡LÍNEA CORREGIDA! (Descomentada) ---

// Exporta las instancias de los servicios para que puedan ser usadas en toda tu aplicación
export { auth, db, functions, storage };